import React, { useContext, useState } from 'react';
import { useModal } from '@europrocurement/flexy-components';
import { AxiosResponse } from 'axios';

import { FproDosDocFileJsonldDocumentfileRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import { useSnackbar } from 'notistack';
import DocumentContext from '../providers/DocumentContext';
import LiasseCheckerForm from '../components/shared/LiasseCheckerForm/LiasseCheckerForm';
import { CreatedLiasseType } from '../providers/types';

const useFileChecker = () => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const { modalActions } = useModal();
    const documentContext = useContext(DocumentContext);
    const { refreshDocumentContext } = useContext(DocumentContext);
    const { documentsApi, fichiersDossierApi } = useFormaliteService();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (filesToRemove: FproDosDocFileJsonldDocumentfileRead[]) => {
        if (isSubmitting) {
            return;
        }
        if (filesToRemove.length > 0) {
            setIsSubmitting(true);

            const validHttpCodes = [200, 204];
            const errors: FproDosDocFileJsonldDocumentfileRead[] = [];

            // Delete FproDosDoc
            filesToRemove.map(async (file) => {
                if (file.id && file.typeDocDossier?.id) {
                    // Delete DosDocFile
                    const fichierDelRepsonse = await fichiersDossierApi.apiFichiersIdDelete({
                        id: file.id.toString(),
                    });
                    if (validHttpCodes.includes(fichierDelRepsonse.status)) {
                        // Delete DosDoc
                        const docDelRepsonse = await documentsApi.apiTypesDocDossierIdDelete({
                            id: file.typeDocDossier.id.toString(),
                        });
                        if (!validHttpCodes.includes(docDelRepsonse.status)) {
                            errors.push(file);
                        }
                    } else {
                        errors.push(file);
                    }
                } else {
                    errors.push(file);
                }
                return file;
            });

            if (errors.length > 0) {
                errors.map((errorFile) =>
                    enqueueSnackbar(
                        `Une erreur est survenue lors de la suppression du fichier ${errorFile.fichier}`,
                        {
                            variant: 'error',
                        },
                    ),
                );
            }
            refreshDocumentContext();
            setIsSubmitting(false);
            modalActions.close();
        } else {
            setIsSubmitting(false);
            modalActions.close();
        }
    };

    const displayFilesCheckerForm = (
        createdFiles: CreatedLiasseType[],
        getFichierContent: (fichierId: number) => Promise<AxiosResponse<void>>,
    ) => {
        // Modal de vérification de fichiers
        modalActions.call(
            <LiasseCheckerForm
                createdLiasses={createdFiles}
                documentContext={documentContext}
                getFichierContent={getFichierContent}
                handleSubmit={handleSubmit}
                isSubmitting={isSubmitting}
            />,
            false,
            true,
        );
    };

    return { displayFilesCheckerForm };
};

export default useFileChecker;
